module.exports = __webpack_public_path__ + "img/image_big_logo.a1efc04f.png";